import { render } from "./AttachmentsColumn.vue?vue&type=template&id=671e384e"
import script from "./AttachmentsColumn.vue?vue&type=script&lang=js"
export * from "./AttachmentsColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__